var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.imageClass, _vm.imageState],style:(_vm.computedStyle + ' ' + _vm.additionalStyle),attrs:{"data-width":_vm.imageWidth,"data-height":_vm.imageHeight,"data-state":_vm.imageState}})
}
var staticRenderFns = []

export { render, staticRenderFns }